import KrFormContainer from 'components/kr/KrFormContainer';

export default function KrMigrationFormPage() {
  const contentfulId = '3RCviulvLb6cUP3VQwFQYh'; // Korea Form Page
  const country = 'KOREA';
  return <KrFormContainer contentfulId={contentfulId} country={country} />;
}
